import React from 'react';
import styled from 'styled-components';
import { History } from 'history';
import Popconfirm from 'antd/es/popconfirm';
import Button from 'antd/es/button';
import { LeftOutlined } from '@ant-design/icons';

import { H2ImgIcon, IconType } from './ImgIcon';

interface PageHeaderProps {
    iconName: string;
    iconType: IconType;
    label: string;
    subLabel?: string;
    children?: JSX.Element;
}

export const PageHeader = ({
    iconName,
    iconType,
    label: typeLabel,
    subLabel: actionLabel,
    children,
}: PageHeaderProps) => {
    return (
        <OuterContainer>
            <Header role="heading" aria-level={1}>
                <Icon name={iconName} type={iconType} alt={typeLabel} />
                {typeLabel} {actionLabel}
            </Header>

            <Action>{children}</Action>
        </OuterContainer>
    );
};

const OuterContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    align-items: baseline;
    grid-gap: ${({ theme }) => theme.spacing.xs};
    margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const Header = styled.h2`
    justify-self: start;
    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        justify-self: center;
    }
`;

const Icon = styled(H2ImgIcon)`
    padding-right: ${({ theme }) => theme.spacing.sm};
`;

const Action = styled.div`
    justify-self: end;
    @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
        justify-self: center;
    }
`;

interface EditablePageHeaderProps extends PageHeaderProps {
    history: History;
}
export const EditablePageHeader = ({
    iconName,
    iconType,
    label,
    subLabel,
    history,
}: EditablePageHeaderProps) => (
    <PageHeader iconName={iconName} iconType={iconType} label={label} subLabel={subLabel}>
        <Popconfirm
            title="If you leave before saving, your changes will be lost."
            onConfirm={() => history.goBack()}>
            <Button type="link" icon={<LeftOutlined aria-hidden />}>
                Back
            </Button>
        </Popconfirm>
    </PageHeader>
);
